module.exports = __webpack_public_path__ + "img/itsm6.346bd960.png";